import { API_BASEURL } from "@/constant"
import store from "@/store"
import { message } from "antd"
import axios from "axios"

export const GET = "GET"
export const POST = "POST"
export const PUT = "PUT"
export const PATCH = "PATCH"
export const DELETE = "DELETE"

// 1.创建类的实例对象
const instance = axios.create({})

// 2.设置api的根路径
switch (process.env.NODE_ENV) {
	case "development":
	case "production":
		instance.defaults.baseURL = '/'//API_BASEURL
		break
	default:
		break
}

// 3.当前请求为跨域类型时是否在请求中协带cookie。
instance.defaults.withCredentials = true

// 4.请求拦截器（添加token）
instance.interceptors.request.use(config => {
	config.headers.Token = store.getState().token
	return config
})

/*
5.响应拦截器
需要特别处理某个错误的时候:
	let param = {}
	try {
		await api.leave_add(param, { _customError: true })
	} catch(e) {
		console.log(e)
		let msg = (e.data && e.data[0]) || e.msg || "出错了"
		message.warning(msg)
	}
*/
instance.interceptors.response.use(
	// 处理正确的网络返回
	(res) => {
		let config = res.config || {}
		let { code, data, msg } = res.data
		if (code !== 0) {
			if (!config._customError) {
				message.warning(msg || "网络异常")
				throw res.data
			}
			throw res.data
		}
		return data
	},
	// 处理http异常
	(err) => {
		if (err?.response?.status) {
			// 处理不同http状态码
			let { status } = err.response
			if (status === 401) {
				// if (window.$location.pathname !== "/login") {
				// 	window.$history.replace("/login")
				// }
			} else if (status === 502) {
				message.warning("服务器正在部署，请稍后~")
			} else {
				message.warning("服务异常，状态码：" + status)
			}
		} else {
			// 不能处理状态码
			message.warning("服务异常")
		}
		return false
	}
)

export async function request(method, url, data = {}, config = {}) {
	let req = {
		method,
		url,
		...config,
	}
	if (method === POST) {
		req.data = data
	} else {
		req.params = data
	}

	try {
		let data = await instance.request(req)
		return data
	} catch(e) {
		throw e
	}
}

// 文件上传属性
export const getUploadProps = (url) => {
	return {
		name: "file",
		action: API_BASEURL + (url || "/file/upload"),
		headers: {
			Token: store.getState().token,
		},
	}
}

// 导出实例
export default instance
